import { map, addIndex } from 'ramda'

const Map = ({ mappable, children }) =>
  addIndex(map)((value, index) => children(value, mappable), mappable)

export default Map
